import { getDictOne } from "@/utils/storage";
const CodeList = getDictOne('position_category');
const eduList = getDictOne('edu_lev_code');
let dictList = [];
let dictList2 = [];

CodeList.map((a) => {
    let obj = {}
    obj.value = a.dictKey;
    obj.label = a.dictValue
    dictList.push(obj);
})
eduList.map((a) => {
    let obj = {}
    obj.value = a.dictKey;
    obj.label = a.dictValue
    dictList2.push(obj);
})


export const jobData = [
    {
        name: "xxx职位",
        area: "眉山市 东坡区",
        companyName: "xxx公司",
        recruitmentNum: 100,
        salary: "13-17k",
        workYear: "3-5",
        education: "本科",
        type: "私营企业",
        enterpriseNum: "100-499",
        treatment: "通讯补贴，员工旅游，五险一金，定期体检，",
        positionStatus: true
    },
    {
        name: "xxx职位",
        area: "眉山市 东坡区",
        companyName: "xxx公司",
        isDelivery: false,
        recruitmentNum: 100,
        salary: "13-17k",
        workYear: "3-5",
        education: "本科",
        type: "私营企业",
        enterpriseNum: "100-499",
        treatment: "通讯补贴，员工旅游，五险一金，定期体检，",
        positionStatus: false,
    },
    {
        name: "xxx职位",
        area: "眉山市 东坡区",
        companyName: "xxx公司",
        recruitmentNum: 100,
        salary: "13-17k",
        workYear: "3-5",
        education: "本科",
        type: "私营企业",
        enterpriseNum: "100-499",
        treatment: "通讯补贴，员工旅游，五险一金，定期体检，",
        positionStatus: true
    },
    {
        name: "xxx职位",
        area: "眉山市 东坡区",
        companyName: "xxx公司",
        isDelivery: false,
        recruitmentNum: 100,
        salary: "13-17k",
        workYear: "3-5",
        education: "本科",
        type: "私营企业",
        enterpriseNum: "100-499",
        treatment: "通讯补贴，员工旅游，五险一金，定期体检，",
        positionStatus: false,
    }
];



export const formConfig = (data) => {
    // console.log('datadatadata',data);

    return [
        {
            type: 'text', label: '职位名称', name: 'job', value: `${data ? data.job : ''}`, placeholder: '请输入职位名称', required: true,
        },
        {
            type: 'Cascader', label: '工作地区', name: 'workArea', value: `${data ? data.workArea : ''}`, placeholder: '请输入工作地区', required: true, options: [{
                value: '1',
                label: '北京'
            }, {
                value: '2',
                label: '上海'
            }, {
                value: '3',
                label: '广州'
            }]
        },
        {
            type: 'select', label: "职位类别", name: 'positionCategory', value: `${data ? data.positionCategory : ''}`, placeholder: '请选择职位类别', required: true, options: dictList
        }
        ,
        {
            type: 'select', label: '学历要求', required: true, name: 'degree', value: `${data ? data.degree : ''}`, placeholder: '请输入学历要求', options: dictList2
        },
        // {
        //     type: 'text', label: '薪资范围',required:true, name: 'salary', value: `${data ? data.salary :''}`, placeholder: '请输入薪资范围'
        // },
        {
            type: 'number', label: '薪资范围最小值', required: true, name: 'salaryMin', value: `${data ? data.salaryMin : ''}`, placeholder: '请输入薪资范围最小值'
        },
        {
            type: 'number', label: '薪资范围最大值', required: true, name: 'salaryMax', value: `${data ? data.salaryMax : ''}`, placeholder: '请输入薪资范围最大值'
        },
        {
            type: 'text', label: '工作经验', required: true, name: 'workExperience', value: `${data ? data.workExperience : ''}`, placeholder: '请输入工作经验'
        },
        {
            type: 'text', label: '招聘人数', required: true, name: 'recruitsNumber', value: `${data ? data.recruitsNumber : ''}`, placeholder: '请输入招聘人数'
        },

        {
            type: 'text', label: '联系人', name: 'jobInformationContacts', value: `${data ? data.jobInformationContacts : ''}`, placeholder: '请输入联系人'
        },
        {
            type: 'text', label: '联系电话', name: 'jobInformationTel', value: `${data ? data.jobInformationTel : ''}`, placeholder: '请输入联系电话', pattern: /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/
        },
        {
            type: 'text', label: '到岗时间', name: 'onDutyTime', value: `${data ? data.onDutyTime : ''}`, placeholder: '请输入到岗时间'
        },
        {
            type: 'text', label: '年龄要求', name: 'ageRange', value: `${data ? data.ageRange : ''}`, placeholder: '请输入年龄要求'
        },
        {
            type: 'text', label: '性别要求', name: 'genderAsk', value: `${data ? data.genderAsk : ''}`, placeholder: '请输入性别要求'
        },
        {
            type: 'text', label: '婚况要求', name: 'marryState', value: `${data ? data.marryState : ''}`, placeholder: '请输入婚况要求'
        },

        {
            type: 'text', label: '福利待遇', name: 'welfare', value: `${data ? data.welfare : ''}`, placeholder: '请输入福利待遇'
        },
        {
            type: 'text', label: '公司邮箱', name: 'jobEmail', value: `${data ? data.jobEmail : ''}`, placeholder: '请输入公司邮箱', pattern: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
        },
        {
            type: 'time', label: '发布时间', name: 'jobReleaseTime', value: `${data ? data.jobReleaseTime : ''}`, placeholder: '请输入发布时间', disabled: true
        },
        {
            type: 'text', label: '公司地址', name: 'workAddress', value: `${data ? data.workAddress : ''}`, placeholder: '请输入公司地址'
        },
        {
            type: 'time', label: '截止日期', name: 'deadline', value: `${data ? data.deadline : ''}`, placeholder: '请输入截止日期',
        },
        {
            type: 'textarea', label: '职位描述', name: 'jobDescription', value: `${data ? data.jobDescription : ''}`, placeholder: '请输入职位描述'
        },
        {
            type: 'textarea', label: '任职要求', name: 'jobRequirements', value: `${data ? data.jobRequirements : ''}`, placeholder: '请输入任职要求'
        },
        {
            type: 'radio', label: '职位状态', name: 'jobInformationState', value: `${data?.jobInformationState || ''}`, placeholder: '', options: [{
                value: 0,
                label: '发布'
            }, {
                value: 3,
                label: '草稿'
            }]
        },
    ]
}
